var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6717 6.5399C10.7693 6.44227 10.9276 6.44227 11.0252 6.5399L11.9091 7.42379C12.0068 7.52142 12.0068 7.67971 11.9091 7.77734L7.70463 11.9818L11.9091 16.1863C12.0068 16.2839 12.0068 16.4422 11.9091 16.5399L11.0252 17.4237C10.9276 17.5214 10.7693 17.5214 10.6717 17.4237L5.40654 12.1586C5.30894 12.061 5.30894 11.9027 5.40654 11.8051L10.6717 6.5399Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0227 6.5399C16.1203 6.44227 16.2786 6.44227 16.3762 6.5399L17.2601 7.42379C17.3577 7.52142 17.3577 7.67971 17.2601 7.77734L13.0556 11.9818L17.2601 16.1863C17.3577 16.2839 17.3577 16.4422 17.2601 16.5399L16.3762 17.4237C16.2786 17.5214 16.1203 17.5214 16.0227 17.4237L10.7575 12.1586C10.6599 12.061 10.6599 11.9027 10.7575 11.8051L16.0227 6.5399Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelClose);
export default __webpack_public_path__ + "static/media/panel-close.05d9d1b3479edd005b5df9fa9f8b9bbf.svg";
export { ForwardRef as ReactComponent };